import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTaskGroupModel, IUnitTaskGroupsSearchParamsModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS = (model?: IUnitTaskGroupsSearchParamsModel) =>
  ['searchUnitTaskGroups', model?.groupName, model?.status, model?.taskType, model?.archived, model?.skip, model?.take].filter(Boolean)

export const searchUnitTaskGroups = async (model: IUnitTaskGroupsSearchParamsModel): Promise<IUnitTaskGroupModel[]> =>
  axios.post('/management/UnitProgramTask/SearchTaskGroups', model).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitTaskGroups

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IUnitTaskGroupsSearchParamsModel
}

export const useManagementSearchUnitTaskGroups = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, staleTime: 0, gcTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS(model),
    queryFn: () => searchUnitTaskGroups(model)
  })
